"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgenciesMutationService = void 0;
class AgenciesMutationService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Update agent information.
     * @param id agent uuid
     * @param requestBody
     * @returns UpdateResponse
     * @throws ApiError
     */
    updateAgent(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/agents/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete agent
     * @param id agent uuid
     * @returns DeleteAgentResponse
     * @throws ApiError
     */
    deleteAgent(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/agents/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Create agency information.
     * @param requestBody
     * @returns CreateAgencyReponse
     * @throws ApiError
     */
    createAgency(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update agency information.
     * @param id agency uuid
     * @param requestBody
     * @returns UpdateResponse
     * @throws ApiError
     */
    updateAgency(id, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/agencies/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete agency
     * @param id agency uuid
     * @returns DeleteResponse
     * @throws ApiError
     */
    deleteAgency(id) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/agencies/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Create agent information of agency.
     * @param id agency uuid
     * @param requestBody
     * @returns CreateAgentResponse
     * @throws ApiError
     */
    createAgent(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/agencies/{id}/agents',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.AgenciesMutationService = AgenciesMutationService;
